import { render, staticRenderFns } from "./printMouldAdd.vue?vue&type=template&id=1a25a592&"
import script from "./printMouldAdd.vue?vue&type=script&lang=js&"
export * from "./printMouldAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports